<script lang="ts" setup>
  import { useMutation } from '@tanstack/vue-query'

  import { useAuthService } from '~/core/services'
  import type { FetchErrorObj } from '~/core/types'

  const emit = defineEmits<{
    (e: 'close'): void
  }>()
  const { t } = useI18n()
  const { resetPassword } = useAuthService()
  const email = ref('')

  const { mutate: reset, isPending: isPendingReset, error } = useMutation<unknown, FetchErrorObj<{ email: string }>, { email: string }>({
    mutationFn: resetPassword,
    onSuccess: () => {
      emit('close')
    },
  })

</script>
<template>
  <div class="c-reset-form">
    <div class="title">
      <SvgIcon
        icon="account"
        :width="22"
        :height="22"
        :desktop-height="32"
        :desktop-width="32"
      />
      <span>Réinitialisation de&nbsp;mot&nbsp;de&nbsp;passe</span>
    </div>
    <div class="sub-title">
      <span> Saisissez votre email et réinitialisez votre mot de passe </span>
    </div>
    <form
      class="form"
      @submit.prevent="() => reset({email})"
    >
      <!-- <InputErrors
        v-if="error"
        :errors="[error.message]"
      /> -->
      <div class="form-top">
        <InputBase
          v-model="email"
          class="input"
          type="email"
          name="email"
          :label="t('common.email')"
          placeholder="exemple@email.com"
          required
          :errors="error?.errors?.email"
        />
      </div>
      <Button
        type="secondary"
        class="button"
        :disabled="isPendingReset"
        button-type="submit"
      >
        Envoyer
      </Button>
    </form>
  </div>
</template>
<style scoped>

.c-reset-form {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-items: center;
  padding: 1.5em;
  overflow-y: auto;

  .title {
    display: flex;
    flex: 1 1 auto;
    flex-direction: row;
    align-items: center;

    span {
      color: var(--color-secondary);
      font-family: Open-Sans, sans-serif;
      font-size: 1.125em;
      font-weight: bold;
      line-height: 1em;
    }

    .c-icon.account {
      margin-right: 1rem;
      color: var(--color-primary);
    }
  }

  .sub-title {
    flex: 0 0 auto;
    margin-top: 1em;

    span {
      color: var(--color-secondary);
      font-family: Open-Sans, sans-serif;
      font-size: 1em;
      font-weight: 600;
      letter-spacing: normal;
      line-height: 1.38;
      opacity: 0.8;
    }
  }

  .form {
    position: relative;
    display: flex;
    width: 100%;
    flex: 1 0 auto;
    flex-direction: column;
    justify-content: space-between;
    margin-top: 2em;

    .input {
      margin-top: 1em;
    }

    .c-button {
      width: 100%;
      flex: 0 0 auto;
      align-items: center;
      margin-top: 3rem;
      color: white;
      font-family: Bariol, sans-serif;
      font-size: 1.25rem;
      font-weight: 600;
      letter-spacing: 1.68px;
      text-transform: uppercase;
    }
  }
}

@media screen and (width >= 1024px) {
  .c-reset-form {
    padding: 0;

    .title {
      span {
        color: var(--color-secondary);
        font-family: Bariol, sans-serif;
        font-size: 2.5em;
        font-weight: bold;
      }

      .c-icon.account {
        margin-right: 1.25rem;
      }
    }

    .sub-title {
      span {
        color: var(--color-secondary);
        font-family: Open-Sans, sans-serif;
        font-size: 1.25em;
        font-weight: 600;
      }
    }
  }
}

</style>
